/* eslint-disable react-native/no-unused-styles */

import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import { theme } from '@sg/garnish';

import { SIDE_PADDING } from '../../upsell.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellAddOnsContainer = (props: UpsellAddOnsContainerProps) => {
  const { palette = 'kale', children, style } = props;

  return (
    <View style={[styles.container, paletteStyles[palette], style]}>
      {children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const paletteStyles = StyleSheet.create({
  kale: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
  },
  cream: {
    backgroundColor: theme.colors.CREAM,
  },
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
    paddingHorizontal: SIDE_PADDING,
    paddingTop: theme.spacing['6'],
    borderRadius: theme.radius.xxlarge,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type UpsellAddOnsContainerProps = PropsWithChildren<{
  palette?: 'kale' | 'cream';
  style?: ViewStyle;
}>;
